import React from 'react';
import PropTypes from 'prop-types';
import {
  KeyboardAvoidingView,
  View,
  ScrollView,
  Image,
  Text,
  ActivityIndicator,
} from 'react-native';
import {
  Button, Input,
} from 'react-native-elements';
import Auth from '@aws-amplify/auth';
import { Formik } from 'formik';
import { object as yupObject } from 'yup';
import { translate } from '../../../locales/i18n';
import styles from '../../../styles';
import {
  imageCommentValidation,
  imageDelayValidation,
} from '../../../modules/validation/Endpoint';
import Endpoint from '../../../modules/data/Endpoint';

const validationSchema = yupObject().shape({
  comment: imageCommentValidation,
  delay: imageDelayValidation,
});

class PublisherImageForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.onSave = this.onSave.bind(this);

    this.state = {
      error: '',
      token: '',
    };
  }

  async componentDidMount() {
    const token = await Auth.currentSession()
      .then((response) => {
        console.log(`got token: ${token}`);
        return response.accessToken.jwtToken;
      })
      .catch((error) => {
        console.log(error);
        return '';
      });

    this.setState({ token });
  }

  async onSave(values, formikBag) {
    const { onSave } = this.props;

    formikBag.setSubmitting(true);
    const err = await onSave(values);
    if (err !== null) {
      console.log('err');
      console.log(err);
      formikBag.setStatus(err);
    }
    formikBag.setSubmitting(false);
  }

  renderForm = ({
    isValid,
    values,
    handleSubmit,
    setFieldValue,
    touched,
    errors,
    setFieldTouched,
    isSubmitting,
    status,
  }) => {
    const {
      image, onCancel, onDel, onSetDefault,
    } = this.props;
    const { token } = this.state;

    // console.log('displaying image');
    // console.log(image);

    if (token === '') {
      return (
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ActivityIndicator size="large" color={styles.primaryColor} />
        </View>
      );
    }

    return (
      <KeyboardAvoidingView
        style={[
          styles.view.form,
          {
            paddingHorizontal: 0,
            marginHorizontal: 0,
            backgroundColor: 'white',
          },
        ]}
        behavior="padding"
      >
        <View style={{
          flex: 1,
          flexDirection: values.direction,
          width: '100%',
        }}
        >
          <View
            style={{
              flex: 1,
              flexDirection: 'column',
              width: '100%',
              height: '100%',
              backgroundColor: '#0008',
            }}
          >
            <Image
              style={{
                flex: 1,
                width: 'auto',
                resizeMode: 'contain',
              }}
              source={{
                uri: Endpoint.getImage(image, token),
              }}
            />
          </View>
          <ScrollView
            contentContainerStyle={{
              backgroundColor: 'white',
              flex: 1,
              paddingTop: 10,
              alignItems: 'center',
            }}
            containerStyle={{
              backgroundColor: 'white',
              flex: 1,
            }}
            style={{ flex: 1 }}
          >
            {status !== undefined && (
              <Text
                style={{
                  color: 'red',
                }}
              >
                {status}
              </Text>
            )}

            <Input
              containerStyle={styles.form.inputContainer}
              labelStyle={styles.form.inputLabel}
              inputStyle={[styles.form.inputInput, { paddingVertical: 10 }]}
              inputContainerStyle={touched.comment && errors.comment ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
              label={`${translate('image_comment')}:`}
              value={values.comment}
              placeholder={translate('image_comment_placeholder')}
              // autoCapitalize="none"
              multiline
              numberOfLines={5}
              onChangeText={(value) => setFieldValue('comment', value)}
              onBlur={() => setFieldTouched('comment')}
              errorMessage={touched.comment && errors.comment ? errors.comment : undefined}
            />
            {/* Enable the below later when the app playback actually supports this. */}
            {/* <Input
              label={`${translate('image_delay')}:`}
              value={values.delay} // ? `${values.delay}` : '0'}
              keyboardType="numeric"
              placeholder={translate('app_eg', { example: '0' })}
              autoCapitalize="none"
              onChangeText={(value) => setFieldValue('delay', value)}
              onBlur={() => setFieldTouched('delay')}
              errorMessage={touched.delay && errors.delay ? errors.delay : undefined}
            /> */}
          </ScrollView>
        </View>
        {/* <View style={{
          backgroundColor: 'white',
          width: '100%',
          justifyContent: 'center',
          flexDirection: 'row',
          flexWrap: 'wrap',
          alignContent: 'space-around',
          ...ifIphoneX({
            paddingBottom: 10,
          }),
        }}
        > */}
        <View style={styles.form.containerButtons}>
          <View style={{ flexDirection: 'row' }}>
            <Button
              title={translate('button_delete')}
              containerStyle={styles.button.primaryContainer}
              buttonStyle={styles.button.primary}
              disabledStyle={styles.button.primaryDisabled}
              titleStyle={styles.button.primaryTitle}
              disabledTitleStyle={styles.button.primaryTitleDisabled}
              onPress={() => onDel(values)}
              disabled={isSubmitting}
              loading={isSubmitting}
              loadingProps={{ size: 'small', color: 'white' }}
            />
            <Button
              title={translate('button_set_default')}
              containerStyle={styles.button.primaryContainer}
              buttonStyle={styles.button.primary}
              disabledStyle={styles.button.primaryDisabled}
              titleStyle={styles.button.primaryTitle}
              disabledTitleStyle={styles.button.primaryTitleDisabled}
              onPress={() => onSetDefault(values)}
              disabled={isSubmitting}
              loading={isSubmitting}
              loadingProps={{ size: 'small', color: 'white' }}
            />
          </View>
          <View style={{ flexDirection: 'row' }}>
            <Button
              title={translate('button_cancel')}
              containerStyle={styles.button.secondaryContainer}
              buttonStyle={styles.button.secondary}
              disabledStyle={styles.button.secondaryDisabled}
              titleStyle={styles.button.secondaryTitle}
              disabledTitleStyle={styles.button.secondaryTitleDisabled}
              onPress={() => onCancel(values)}
            />
            <Button
              title={translate('button_save')}
              containerStyle={styles.button.primaryContainer}
              buttonStyle={styles.button.primary}
              disabledStyle={styles.button.primaryDisabled}
              titleStyle={styles.button.primaryTitle}
              disabledTitleStyle={styles.button.primaryTitleDisabled}
              onPress={handleSubmit}
              disabled={!isValid || isSubmitting}
              loading={isSubmitting}
              loadingProps={{ size: 'small', color: 'white' }}
            />
          </View>
        </View>
      </KeyboardAvoidingView>
    );
  }

  render() {
    const {
      image, direction,
    } = this.props;
    const { error } = this.state;

    if (image === undefined) {
      return (
        <>
        </>
      );
    }

    const { comment, delay } = image;

    return (
      <Formik
        style={{ flexDirection: direction, height: '100%' }}
        initialValues={{
          error,
          direction,
          comment,
          delay: `${delay || 0}`,
        }}
        enableReinitialize
        validateOnMount
        validationSchema={validationSchema}
        onSubmit={(values, formikBag) => this.onSave(values, formikBag)}
      >
        {this.renderForm}
      </Formik>
    );
  }
}

PublisherImageForm.defaultProps = {
};

PublisherImageForm.propTypes = {
  image: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDel: PropTypes.func.isRequired,
  onSetDefault: PropTypes.func.isRequired,
  direction: PropTypes.string.isRequired,
};

export default PublisherImageForm;
